import { useState, useEffect } from 'react';

export enum ColorOptionsType {
  Default = 'default',
  Test = 'test'
}
export enum ModeOptionsType {
  Light = 'light',
  Dark = 'dark',
}
export type ThemeType = {
  color: ColorOptionsType;
  mode: ModeOptionsType;
};

const colorOptions: ColorOptionsType[] = Object.values(ColorOptionsType);
const modeOptions: ModeOptionsType[] = Object.values(ModeOptionsType);

const formatThemeString = (theme: ThemeType): string => {
  return `theme-${theme.color} theme-${theme.mode}`;
};

export const useTheme = () => {
  const [theme, setTheme] = useState<ThemeType>({ color: ColorOptionsType.Default, mode: ModeOptionsType.Light });

  useEffect(() => {
    const getTheme = () => {
      const localColor = localStorage.getItem('theme-color');
      const localMode = localStorage.getItem('theme-mode');

      if (localColor) {
        setTheme((prevTheme) => ({ ...prevTheme, color: localColor as ColorOptionsType }));
      }
      if (localMode) {
        setTheme((prevTheme) => ({ ...prevTheme, mode: localMode as ModeOptionsType }));
      }
    };

    getTheme();
  }, []);

  const saveTheme = (newTheme: ThemeType) => {
    localStorage.setItem('theme-color', newTheme.color);
    localStorage.setItem('theme-mode', newTheme.mode);

    setTheme(newTheme);
  };

  const themeString = formatThemeString(theme);


  return { theme, saveTheme, themeString, colorOptions, modeOptions};
};